export default {
  header: 'Vaya, ocurrió algo inesperado',
  text: 'Reinicia la página o pulsa el botón «Volver al menú» a continuación.',
  button: 'Volver al inicio',
};
